import { Grid, Typography } from '@mui/material'
import React from 'react'

import {
  adornMagnitudePercentage,
  getMaxArgValues
} from 'components/scenarios/utils/attack-arguments'
import { type AttackCliArgs } from 'types/api/attacks/details/targeting'
import { type Metadata } from 'types/metadata'
import { naturalSortBy } from 'utils/list'
import {
  type DisplayableArgMetadata,
  getMetaForDisplayableArgs
} from 'utils/metadata'

export const AttackNodeArguments: React.FC<{
  allAttackArgs: DisplayableArgMetadata[][]
  args: AttackCliArgs
  metadata: Metadata
}> = ({ args, metadata, allAttackArgs }) => {
  const displayableArgs = getMetaForDisplayableArgs(args, metadata)

  // FYI, we can receive args in any order because they're not saved in a consistent state
  // sort args so the ones we display as icons are consistent
  const sortedArgs = naturalSortBy(displayableArgs, (arg) => arg.name)
  const maxArgValues = getMaxArgValues(allAttackArgs)
  const magnitudeArgs = adornMagnitudePercentage(sortedArgs, maxArgValues)

  return (
    <Grid
      container
      data-testid="attack-graph-node-magnitude-tooltip-content"
      rowSpacing={0}
      sx={{ maxWidth: 250 }}
    >
      {magnitudeArgs.map((arg) => (
        <Grid
          key={arg.name}
          container
          columns={2}
          justifyContent="center"
          spacing={1}
          wrap="nowrap"
        >
          <Grid item>
            <Typography noWrap variant="body2">
              {arg.name}:
            </Typography>
          </Grid>
          <Grid item sx={{ marginLeft: 'auto' }}>
            <Typography noWrap variant="body2">
              {String(arg.value)}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}
